var fetch = require('node-fetch');

var NodeContentServerHelper = {};

module.exports = NodeContentServerHelper;

NodeContentServerHelper.request = function(requestMethod, requestURL, requestHeaders, data, sync, jsonResponseExpected) {
    if(sync) {
        throw new Error("synchronous requests not supported");
    }

    requestHeaders["Cookie"] = "CS_SESSION=" + this.session;

    var options = {
        method: requestMethod,
        headers: requestHeaders
    };

    if(data) {
        options.body = data;
    }

    return fetch(requestURL, options)
    .then(function(res) {
        if(!res.ok) {
            throw new Error('Content server error: "' + res.statusText + '", url: ' + requestURL);
        }

        if(res.status == 204) return;

        if(jsonResponseExpected) {
            return res.json();
        } else 
            return res.text();
    })
    .then(function(resBody) {
        return resBody;
    });
};
